import AppBar from '@material-ui/core/AppBar';
import Customer from 'models/Customer';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import Menu from '@material-ui/icons/Menu';
import PropTypes from 'prop-types';
import React from 'react';
import ToolBar from '@material-ui/core/Toolbar';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import NavAppBarRightIcons from './NavAppBarRightIcons';
import SearchFieldContainer from '../containers/SearchFieldContainer';

const styles = theme => ({
	appBarRoot: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
		height: 80,
		boxShadow: 'none',
	},
	flex: {
		height: 64,
		flex: 1,
	},
	toolbar: {
		padding: 8,
		height: 'inherit',
		position: 'relative',
	},
	searchDisplay: {
		position: 'absolute',
		top: 0,
		paddingTop: 6,
		left: 'calc(100px + 2%)',
		height: 80,
		zIndex: 1111,

		[theme.breakpoints.down('xs')]: {
			left: 80,
		},
	},
	rightIcons: {
		marginLeft: 'auto',
		marginRight: 16,
		marginTop: 16,
		height: 80,
		color: theme.palette.common.black,
	},
	logo: {
		display: 'none',

		[theme.breakpoints.up('md')]: {
			display: 'initial',
			position: 'absolute',
			top: 5,
			/* height of nav bar is 80px, so give logo a height of 70px so it has 5px margins on top and bottom */
			height: 70,
			/* start the left side of the logo at the middle (50%) */
			left: '50%',
			/* then center by moving it to the left by half of its size */
			transform: 'translateX(-50%)',
			/* the z-index is 10 more than the navappbar */
			zIndex: 1110,
		},
	},
	logoImg: {
		objectFit: 'contain',
		height: '100%',

		[theme.breakpoints.up('md')]: {
			maxWidth: 70,
		},
		[theme.breakpoints.up('lg')]: {
			maxWidth: 360,
		},
		[theme.breakpoints.up('xl')]: {
			maxWidth: 950,
		},
	},
	menu: {
		width: '36px',
		height: '80px',
		cursor: 'pointer',
		margin: '-8px',
		padding: '0 20px 0 48px',
		color: theme.palette.common.black,

		[theme.breakpoints.down('xs')]: {
			paddingLeft: 20,
		},
	},
});

const NavAppBar = props => {
	const {
		classes,
		customer,
		logo,
		logout,
		openLogin,
		openRegistration,
		toggleMainDrawer,
		toggleCartDrawer,
	} = props;
	return (
		<div>
			<AppBar className={classes.appBarRoot} position="static">
				<ToolBar className={classes.toolbar}>
					<Menu className={classes.menu} onClick={toggleMainDrawer} />
					{logo !== undefined ? (
						<div className={classes.flex}>
							<div className={classes.logo}>
								<Link to="/category" style={{ display: 'block', height: '100%' }}>
									<img src={logo} alt="STORIS" className={classes.logoImg} />
								</Link>
							</div>
						</div>
					) : null}
					<ErrorBoundary>
						<div className={classes.rightIcons}>
							<NavAppBarRightIcons
								customer={customer}
								logout={logout}
								openLogin={openLogin}
								openRegistration={openRegistration}
								toggleCartDrawer={toggleCartDrawer}
							/>
						</div>
					</ErrorBoundary>
				</ToolBar>
			</AppBar>
			<div className={classes.searchDisplay}>
				<ErrorBoundary>
					<SearchFieldContainer />
				</ErrorBoundary>
			</div>
		</div>
	);
};

NavAppBar.propTypes = {
	classes: PropTypes.shape({
		appBarRoot: PropTypes.string,
		flex: PropTypes.string,
		toolbar: PropTypes.string,
		rightIcons: PropTypes.string,
		searchDisplay: PropTypes.string,
		logo: PropTypes.string,
		logoImg: PropTypes.string,
		menu: PropTypes.string,
	}).isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	logo: PropTypes.string,
	logout: PropTypes.func.isRequired,
	openLogin: PropTypes.func.isRequired,
	openRegistration: PropTypes.func.isRequired,
	toggleCartDrawer: PropTypes.func.isRequired,
	toggleMainDrawer: PropTypes.func.isRequired,
};

NavAppBar.defaultProps = {
	logo: undefined,
};

// for testing purposes
export { NavAppBar as NavAppBarClass };

export default compose(withStyles(styles, { name: 'NavAppBar' }))(NavAppBar);
